import React from 'react';
import { Image } from 'antd-mobile';

import styles from './index.module.less';

import tipImg from '@/assets/images/pic_yddj.png';

interface SnapshotMaskProps {
  visible: boolean;
}

const SnapshotMask: React.FC<SnapshotMaskProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className={styles.snapshotMask} role='dialog' aria-live='polite'>
      <Image className={styles.snapshotIcon} src={tipImg} />
    </div>
  );
};

export default SnapshotMask;
